// src/components/common/ConfirmMorphCloseButton.js
//
// The morph gate's corner ✕ (founder report, 2026-09-24) — extracted out of
// ConfirmMorphActions so the two confirm shells (ConfirmDialog,
// ConfirmDialogInline) can render it once at the shell level. The ✕ is the
// shared corner button (`position: absolute`, KAN-948), so it must anchor to
// the PANEL, not to an inner `position: relative` wrapper; callers that pass
// `hideCloseButton` to ConfirmMorphActions get it from the shell instead.

import { useIntl } from 'react-intl';
import OverlayCloseButton from './overlay/OverlayCloseButton';

const MORPH_MS = 320;
const EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

/**
 * The morph's ✕ is the shared round close button (OverlayCloseButton, KAN-948) wearing the
 * morph's reveal (opacity + scale). Its accessible name stays `common.cancel`: ✕ and Cancel are
 * one control in two shapes (PLAYBOOK, Confirmation GATES).
 *
 * @param {boolean} armed - the morph gate's armed state (visible/interactive
 *   only once armed, exactly like ConfirmMorphActions' own ✕).
 * @param {boolean} busy - disables the button (own busy OR the beat working).
 * @param {Function} onCancel - same dismiss handler as the shell's Cancel.
 * @param {boolean} reduced - reduced-motion: no transition.
 */
export default function ConfirmMorphCloseButton({ armed, busy, onCancel, reduced }) {
  const intl = useIntl();
  return (
    <OverlayCloseButton
      onClick={onCancel}
      disabled={busy}
      // Same accessibility contract as before: visible + reachable only once armed (hidden =
      // aria-hidden, out of the tab order, inert - see the note in ConfirmMorphActions).
      hidden={!armed}
      label={intl.formatMessage({ id: 'common.cancel', defaultMessage: 'Cancel' })}
      testId="confirm-morph-close"
      style={{
        opacity: armed ? 1 : 0,
        transform: armed ? 'scale(1)' : 'scale(0.82)',
        transition: reduced ? 'none' : `opacity 220ms ease, transform ${MORPH_MS}ms ${EASE}`,
      }}
    />
  );
}
